import React from 'react'
import OurOffers from '../../Components/slider/OurOffers'
import { useNavigate } from 'react-router-dom'

function AiServices() {
     const navigate = useNavigate()
    return (
        <>
            <div className='bg-[#000000]'>
                {/* <section className="relative w-full z-10 min-h-screen flex items-center justify-center">
                    <img src="/assets/mobi/bg4.jpg" className="absolute top-0 left-0 w-full h-full object-cover -z-10" alt="hero-bg" />
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="absolute top-0 left-0 w-full h-full object-cover -z-10"
                    >
                        <source src="/assets/v/services.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                    <div className="absolute inset-0 bg-black/40 -z-10"></div>
                    <div className="relative z-10 about-content max-w-[960px] w-full mx-auto px-4 lg:px-0">
                        <h1   className="font-[400] uppercase text-[36px] tracking-[6px] text-center lg:text-[56px] leading-[42px] lg:leading-[72px] text-[#FFFFFF]">
                            Ai Services
                        </h1>
                        <div className="max-w-[20%] w-full mx-auto border-t-[4px] border-[#c00d0d]"></div>
                    </div>
                    <div className='bottom-black'></div>
                </section> */}
                {/* <section className='-mt-[150px]'>
                    <div className="max-w-[1188px] w-full mx-auto grid lg:grid-cols-2 items-center grid-cols-1 gap-[8px]">
                        <div className='grid gap-[8px]'>
                            <div className='relative w-full opacity-0 '>
                                <img src="/assets/about/img1.jpg" className='w-full object-cover' alt="" />
                                <div className='absolute bottom-[50px] left-[30px] text-[#FFFFFF]'>
                                    <h6 className="text-[34px] mb-[20px] uppercase font-[400]"  > Culture, Values and ESG</h6>
                                    <Link   className='py-[10px] transition-all duration-500 hover:opacity-100 bg-[#ED6800] opacity-70 text-[#fff] text-[20px] uppercase px-[20px]' to="/services/service-detail">
                                        Read more
                                    </Link>
                                </div>
                            </div>
                            <div className='relative w-full '>
                                <img src="/assets/services/item1.webp" className='w-full object-cover' alt="" />
                                <div className="absolute inset-0 bg-[#00000033] z-10"></div>
                                <div className='absolute bottom-[50px] z-20 left-[30px] text-[#FFFFFF]'>
                                    <h6 className="text-[34px] mb-[20px] uppercase font-[400]"  > Agentic AI Services for Enterprises</h6>
                                    <Link   className='py-[10px] transition-all duration-500 hover:opacity-100 bg-[#ED6800] opacity-70 text-[#fff] text-[20px] uppercase px-[20px]' to="/agentic-ai-services">
                                        Read more
                                    </Link>
                                </div>
                            </div>
                            <div className='relative w-full lg:block hidden opacity-0 '>
                                <img src="/assets/about/item2.png" className='w-full object-cover' alt="" />
                                <div className="absolute inset-0 bg-[#00000033] z-10"></div>
                                <div className='absolute bottom-[50px] left-[30px] z-20 text-[#FFFFFF]'>
                                    <h6 className="text-[34px] mb-[20px] uppercase font-[400]"  > Culture, Values and ESG</h6>
                                    <Link   className='py-[10px] transition-all duration-500 hover:opacity-100 bg-[#ED6800] opacity-70 text-[#fff] text-[20px] uppercase px-[20px]' to="/services/service-detail">
                                        Read more
                                    </Link>
                                </div>
                            </div>
                        </div>
                       
                        <div className='grid gap-[8px] lg:pb-0 pb-[40px]'>
                            <div className='relative w-full '>
                                <img src="/assets/services/item5.webp" className='w-full object-cover' alt="" />
                                <div className="absolute inset-0 bg-[#00000033] z-10"></div>
                                <div className='absolute bottom-[50px] left-[30px] z-20 text-[#FFFFFF]'>
                                    <h6 className="text-[34px] mb-[20px] uppercase font-[400]"  > AI & Automation Services</h6>
                                    <Link   className='py-[10px] transition-all duration-500 hover:opacity-100 bg-[#ED6800] opacity-70 text-[#fff] text-[20px] uppercase px-[20px]' to="/ai-automation-services">
                                        Read more
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
                {/* 
                <div className='career-banner career-banner2'>
                    <div className='career-banner-overlay '>
                        <div className="max-w-[1200px] h-[200px] w-full flex flex-col justify-center mx-auto lg:px-[12px] px-[20px]">
                            <h3 className='text-[44px]'>AI & Automation</h3>
                            <p>Smarter Workflows, Faster Growth.</p>
                        </div>
                        
                    </div>
                </div> */}
                <div className='career-banner career-banner7 career-banner4'>
                    <div className='career-banner-overlay text-[#FFFFFF] career-banner-overlay2'>
                        <div className="max-w-[1200px] w-full mx-auto lg:px-[12px] px-[20px]">
                            <h3 style={{ textAlign: "left" }} className='heading-text'>AI & Automation</h3>
                            <p>Smarter Workflows, Faster Growth.</p>
                        </div>
                    </div>
                </div>

                <br />
                <br />
                <br />

                <div className='max-w-[1200px] mx-auto w-full lg:px-[12px] px-[20px]'>
                    <div className="grid lg:grid-cols-2 grid-cols-1">
                        <div className="lg:max-w-[480px] max-w-[100%] w-full text-[#FFFFFF]">
                            <h6 className="heading-text mb-[24px]">
                                Cognitive Edge.<br /> Real-World Impact.
                            </h6>
                            <p className="font-graphik text-justify text-[16px] font-[400] leading-[24px] mb-[20px] md:mb-[36px]">
                                At Mobikode, we don’t just build AI, we engineer intelligent systems that think, act, and adapt like agents of change. Our Agentic AI services empower enterprises to automate complex processes, augment human decision-making, and unlock transformative business outcomes.
                            </p>
                        </div>
                        <div>
                            <img src="/assets/about/bg1.jpg" alt="" />
                        </div>
                    </div>
                </div>
                <div className="max-w-[1200px] w-full mx-auto lg:px-[12px] px-[20px]">
                    <div className="lg:pt-[60px] pt-[40px]">
                        <h6 className="heading-text text-[#FFFFFF] pb-[13px]">
                            Our AI Offerings
                        </h6>
                        <div className='lg:pt-[40px] pt-[40px]'>
                            <div className="relative overflow-hidden">
                                <OurOffers />
                                {/* <div className='absolute lg:bottom-[96px] bottom-[50px] right-0 '>
                                    <button style={{ border: '2px solid rgba(167, 167, 167, 0.31)' }} className="border group flex gap-[16px] items-center hover:border-[#ed6800] border-[#FFFFFF] font-graphik py-[10px] px-[20px] text-[#FFFFFF] font-[400] text-[20px] leading-[24px] bg-transparent hover:bg-[#ED6800] transition-all duration-300 tracking-[1px]">
                                        View All
                                        <img
                                            src="/assets/tab/icon-right.svg"
                                            className="h-[26px] filter invert transition-transform dark:invert-0   duration-300 group-hover:translate-x-2"
                                            alt="arrow"
                                        />  </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className='max-w-[1200px] mx-auto w-full lg:px-[12px] px-[20px] lg:pt-[80px] pt-[40px]'>
                    <div className='ai-services-div'>
                        <div className='ai-services-div-card'>
                            <div className='ai-services-div-card-overlay'>

                                <h3>Agentic AI Services for Enterprises</h3>
                                <Link to='/agentic-ai-services'>

                                    <button>Read More</button>
                                </Link>
                            </div>
                        </div>
                        <div className='ai-services-div-card ai-services-div-card2'>
                            <div className='ai-services-div-card-overlay'>

                                <h3>AI & Automation Services</h3>
                                <Link to='/ai-automation-services'>

                                    <button>Read More</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div> */}


                {/* <br />
                <br /> */}
                {/* <section className='lg:px-0 px-[20px]'>
                    <div className="h-[246px] relative max-w-[1040px] w-full mx-auto overflow-hidden text-[#FFFFFF]">
                        <img src="/assets/about/img9.jpg" className='object-cover h-[246px] w-full' alt="" />
                        <div className="absolute px-[44px] top-[50%] translate-y-[-50%] flex items-start flex-col justify-center">
                            <h6   className="lg:text-[30px] text-[20px] font-[600] uppercase pb-[12px]">
                                GenERATIVE AI AT MOBIKODE
                            </h6>
                            <p className="lg:text-[18px] text-[14px] font-[400] lg:leading-[28px] leading-[24px] mb-[16px]">
                                MOBIKODE can help you identify compelling use cases and unlock game-changing solutions to help you benefit from the power of GenAI.
                            </p>
                            <Link   className='py-[10px] transition-all font-[600] lg:text-[24px] text-[20px] duration-500 border border-[#FFFFFF] text-[#fff] uppercase px-[20px]'>
                                Discover more
                            </Link>
                        </div>
                    </div>
                </section> */}
                <div className="max-w-[1200px] w-full mx-auto lg:pt-[40px] lg:pb-[80px] pb-[40px] lg:px-[12px] px-[20px]">
                    <h6 className="heading-text text-[#FFFFFF] pb-[13px]">
                        Why Mobikode for AI?
                    </h6>
                    <div className='lg:pt-[70px] pt-[40px] grid lg:grid-cols-3 grid-cols-1 gap-[20px]'>
                        <div className='border border-transparent transition-all overflow-hidden duration-300 group hover:border-[#ED6800] relative bg-[#242424]'>
                            <div className="p-[20px] w-full">
                                <h6 className="text-[#FFFFFF] font-graphik text-[24px] leading-[30px] font-[700]">Enterprise-ready AI: </h6>
                                <ul className='list-disc pl-[20px] pt-[20px]'>
                                    <li className='text-[16px] font-graphik font-[200] leading-[24px] text-[#FFFFFF]'> Designed for scale, security, and performance.</li>
                                </ul>
                            </div>
                        </div>
                        <div className='border border-transparent transition-all overflow-hidden duration-300 group hover:border-[#ED6800] relative bg-[#242424]'>
                            <div className="p-[20px] w-full">
                                <h6 className="text-[#FFFFFF] font-graphik text-[24px] leading-[30px] font-[700]">Domain depth:</h6>
                                <ul className='list-disc pl-[20px] pt-[20px]'>
                                    <li className='text-[16px] font-graphik font-[200] leading-[24px] text-[#FFFFFF]'>Proven expertise across Oil & Gas, BFSI, Manufacturing, and Digital Workspaces.</li>
                                </ul>
                            </div>
                        </div>
                        <div className='border border-transparent transition-all overflow-hidden duration-300 group hover:border-[#ED6800] relative bg-[#242424]'>
                            <div className="p-[20px] w-full">
                                <h6 className="text-[#FFFFFF] font-graphik text-[24px] leading-[30px] font-[700]">Faster ROI:</h6>
                                <ul className='list-disc pl-[20px] pt-[20px]'>
                                    <li className='text-[16px] font-graphik font-[200] leading-[24px] text-[#FFFFFF]'>Deployments optimized for measurable business impact, not just prototypes.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='max-w-[1200px] lg:pb-[80px] pb-[40px] mx-auto w-full lg:px-[12px] px-[20px]'>
                    <div className="h-[246px] relative max-w-[1200px] w-full mx-auto overflow-hidden text-[#FFFFFF]">
                        <img src="/assets/about/img9.jpg" className='object-cover h-[246px] w-full' alt="" />
                        <div className="overay absolute px- top-[50%] translate-y-[-50%] flex items-start flex-col justify-center">
                            <h6 className="lg:text-[40px] text-[24px] font-[400] pb-[12px]">
                                Ready to accelerate your AI journey?
                            </h6>
                            <p className="text-opacity-80 text-[#FFFFFF] font-[400] lg:text-[16px] text-[14px] lg:leading-[28px] leading-[22px] mb-[30px]">
                                Partner with Mobikode to turn intelligence into advantage.
                            </p>
                            <button onClick={()=>{navigate('/ai-automation-services')}} style={{ border: '2px solid rgba(167, 167, 167, 0.31)' }} className=" banner-btn group border flex gap-[16px] items-center hover:border-[#ed6800] border-[#FFFFFF] font-graphik py-[10px] px-[24px] text-[#FFFFFF] font-[400] lg:text-[20px] text-[16px] lg:leading-[24px] leading-[22px] bg-transparent transition-all duration-300 tracking-[1px]">
                                Discover more
                                <img
                                    src="/assets/tab/icon-right.svg"
                                    className="h-[26px] filter invert transition-transform dark:invert-0   duration-300 group-hover:translate-x-2"
                                    alt="arrow"
                                />  </button>
                        </div>
                    </div>
                </div>
                {/* <div className='max-w-[1200px] mx-auto w-full lg:px-[12px] px-[20px]'>
                    <section>
                        <h1 className="font-[400] py-[60px] text-[36px] text-center lg:text-[44px] leading-[42px] lg:leading-[72px] text-[#FFFFFF]">
                            LATEST INTELLIGENCE FROM MOBIKODE
                        </h1>
                        <div className='max-w-[1320px] w-full mx-auto pb-[70px]'>
                            <div className='grid lg:grid-cols-3 grid-cols-1 gap-[40px]'>
                                <div>
                                    <img src="/assets/mobi/item1.jpg" className="h-[242px] object-cover w-full" alt="" />
                                    <div>
                                        <h6 className="py-[16px] text-[25px] font-[400] leading-[35px] text-[#FFFFFF]"  >Innovating with Intelligence: Open-Source Large Language Models for Secure System Transformation
                                        </h6>
                                        <p className="text-[16px] text-justify font-[400] leading-[28px] text-[#FFFFFF]">Large Language Models have emerged as a transformative technology, but which LLM is best for your business? Our paper offers a comprehensive review of leading models available and a robust method for assessing their costs and benefits for any given use case.</p>
                                    </div>
                                </div>
                                <div>
                                    <img src="/assets/mobi/item2.jpg" className="h-[242px] object-cover w-full" alt="" />
                                    <div>
                                        <h6 className="py-[16px] text-[25px] font-[400] leading-[35px] text-[#FFFFFF]"  >Leveraging MAS Insights for Effective Data Management & Governance
                                        </h6>
                                        <p className="text-[16px] text-justify font-[400] leading-[28px] text-[#FFFFFF]">Financial institutions need to improve data practices to satisfy regulators and support a widening range of critical functions. This article draws on a recent MAS paper to offer insights on how to improve data capabilities in areas such as board oversight, data management organization, and data issues identification and escalation. </p>
                                    </div>
                                </div>
                                <div>
                                    <img src="/assets/mobi/item3.jpg" className="h-[242px] object-cover w-full" alt="" />
                                    <div>
                                        <h6 className="py-[16px] text-[25px] font-[400] leading-[35px] text-[#FFFFFF]"  >Artificial Intelligence (AI) for regulatory impact analysis
                                        </h6>
                                        <p className="text-[16px] text-justify font-[400] leading-[28px] text-[#FFFFFF]">MOBIKODE’s Center of Regulatory Intelligence’s (CRI’s) Data Feed has been tracking these trends, and one thing remains clear: regulators agree that while danger exists, there can also be huge benefits to using AI technologies in ways that promote consumer protections and fairness.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div> */}
            </div>
        </>
    )
}

export default AiServices